import React from "react";

type Props = {
  children: React.ReactNode;
  className?: string;
  inline?: boolean;
};

export default function ErrorAlert({
  children,
  className = "",
  inline = false,
}: Props) {
  if (!children) return null;

  return (
    <p
      role="alert"
      className={
        inline
          ? `text-xs text-red-700 ${className}`.trim()
          : `text-sm text-red-700 bg-red-50 border border-red-200 rounded-sm p-3 ${className}`.trim()
      }
    >
      {children}
    </p>
  );
}
